import { render, staticRenderFns } from "./TendersFiltersDialog.vue?vue&type=template&id=9881c926"
import script from "./TendersFiltersDialog.vue?vue&type=script&lang=js"
export * from "./TendersFiltersDialog.vue?vue&type=script&lang=js"
import style0 from "./TendersFiltersDialog.vue?vue&type=style&index=0&id=9881c926&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports